import { useRef, useState } from 'react';
import HelpTooltip from '../HelpTooltip';
import { warningMessage } from '@/utils/toast';
import type { IHeaderParams } from 'ag-grid-community';
import type { ReactNode, MouseEvent as ReactMouseEvent } from 'react';
import type { AgGridRowData } from './types';

interface AgGridHeaderParams extends IHeaderParams<AgGridRowData> {
  icon?: ReactNode;
  tooltip?: ReactNode;
}

const AgGridHeader = (params: AgGridHeaderParams) => {
  const menuOpener = useRef<HTMLSpanElement | null>(null);
  const [sortState, setSortState] = useState(params.column.getSort());
  const onMenuClicked = () => {
    if (menuOpener.current) {
      params.showColumnMenu(menuOpener.current);
    }
  };
  params.column.addEventListener('sortChanged', function () {
    setSortState(params.column.getSort());
  });

  const onSortClicked = (event: ReactMouseEvent<HTMLDivElement>) => {
    if (params.enableSorting) {
      params.progressSort(event.shiftKey);
      params.api.refreshHeader();
    } else {
      warningMessage('این ستون مرتب سازی نداره');
    }
  };
  return (
    <>
      {params.displayName.length >= 2 && (
        <div
          className="d-flex w-100 justify-content-between"
          onClick={e => onSortClicked(e)}
        >
          <div className="d-flex align-items-center">
            <span style={{ marginTop: '-5px' }} className="me-1">
              {params.icon}
            </span>
            <span className="ag-header-cell-text">{params.displayName}</span>
            {params.tooltip && <HelpTooltip html={params.tooltip} />}
            {params.enableSorting && (
              <span
                className={`ag-icon ${
                  sortState === 'desc'
                    ? 'ag-icon-desc'
                    : sortState === 'asc'
                      ? 'ag-icon-asc'
                      : null
                } `}
                role="presentation"
              ></span>
            )}
          </div>
          <div>
            {params.enableMenu && (
              <span
                className="ag-icon cursor-pointer ag-icon-menu ms-auto"
                onClick={e => {
                  e.stopPropagation();
                  onMenuClicked();
                }}
                ref={menuOpener}
              ></span>
            )}
          </div>
        </div>
      )}
    </>
  );
};

export default AgGridHeader;
